import React, { Component } from "react";
import moment from "moment";

class LogsListRow extends Component {
  render() {
    const { log } = this.props;

    let success = "";
    if (log.Success) {
      success = "Yes";
    } else {
      success = "No";
    }

    return (
      <tr>
        <td>{log.ApplicationName}</td>
        <td>{log.ApplicationVersion}</td>
        <td>{moment(log.Date).format("L LTS")}</td>
        <td>{log.Domain}</td>
        <td>{log.UsedLogin}</td>
        <td>{log.IpAddress}</td>
        <td>{success}</td>
        <td>{log.Message}</td>
      </tr>
    );
  }
}

export default LogsListRow;



// WEBPACK FOOTER //
// ./src/Components/LogsList/LogsListRow.js